import { UserStatus } from '@zorro/clients';
import { Pill, PillColor } from '@zorro/design-system/v2/Pill';

export const agentBadgeConfig: {
  [status in UserStatus]: {
    color: PillColor;
    label: string;
  };
} = {
  [UserStatus.NOT_ACTIVATED]: {
    color: 'red',
    label: 'Not activated',
  },
  [UserStatus.PENDING_LOGIN]: {
    color: 'orange',
    label: 'Not invited',
  },
  [UserStatus.PENDING_INVITATION]: {
    color: 'indigo',
    label: 'Invited',
  },
  [UserStatus.ACTIVATED]: {
    color: 'green',
    label: 'Activated',
  },
};

type Props = {
  status: UserStatus;
};

export const AgentStatusBadge = ({ status }: Props) => {
  const { color, label } = agentBadgeConfig[status ?? UserStatus.PENDING_LOGIN];

  return (
    <Pill color={color} variant="tag">
      {label}
    </Pill>
  );
};
